exports.ERegExp = {

    MUST_HAVE_LETTERS_OR_NUMBERS: { regexp: new RegExp(/[A-Za-z0-9]/) },
    MUST_HAVE_LETTERS: { regexp: new RegExp(/[A-Za-z]/) },
    MUST_HAVE_NUMBERS: { regexp: new RegExp(/[0-9]/) },
    ONLY_HAVE_NUMBERS: { regexp: new RegExp(/^[0-9]*$/) }

}